import barba from '@barba/core';
import transitions from './transitions/transitions';

function ensureSharingUrlIsCorrect(nextHtmlDoc){

	const head = document.querySelector('head');
	head.querySelectorAll('meta,link[rel=canonical],link[rel=alternate]').forEach(el => {
		el.remove();
	});

	const nextHead = nextHtmlDoc.querySelector('head');

	nextHead.querySelectorAll('meta,link[rel=canonical],link[rel=alternate]').forEach(el => {
		head.appendChild(el);
	})

}

export default class Spa {
	constructor() {
		let scrollX = 0;
		let scrollY = 0;

		if (history.scrollRestoration) {
			history.scrollRestoration = 'manual';
		}

		// Global Barba hooks
		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			try {
				const parser = new DOMParser();
				const htmlDoc = parser.parseFromString(next.html, 'text/html');
				const html = htmlDoc.documentElement;

				const lang = html.attributes.getNamedItem('lang')?.nodeValue;

				if (lang) {
					const existingLang = document.documentElement.attributes.getNamedItem('lang');

					if (existingLang) {
						existingLang.nodeValue = lang;
					}
				}
			} catch (e) {
				console.error(e);
			}

			const blessEvent = new CustomEvent('bless', {
				detail: {
					element: next.container,
					trigger: trigger,
				},
			});
			document.dispatchEvent(blessEvent);
		});

		barba.hooks.leave(({ current, next, trigger }) => {
			if (trigger !== 'back') {
				scrollX = barba.history.current.scroll.x;
				scrollY = barba.history.current.scroll.y;
			}
		});

		barba.hooks.enter(({ current, next, trigger }) => {
			if (trigger == 'back') {
				window.scrollTo(scrollX, scrollY);
			} else {
				window.scrollTo(0, 0);
			}
		});

		barba.hooks.after(({ current, next, trigger }) => {
			// Do stuff like tracking, update header, etc.
			var parser = new DOMParser();
			var htmlDoc = parser.parseFromString(next.html, 'text/html');

			ensureSharingUrlIsCorrect(htmlDoc);

			const scripts = htmlDoc.getElementsByTagName('script');

			function evalInWindow(src) {
				const func = function () {
					eval(src);
				};

				//define event to prevent errors in gform javascript
				const backup = window.event;
				window.event = {};
				func.call(window);
				delete window.event;
				if (backup !== undefined) {
					window.event = backup;
				}else{
					window.event = {
						preventDefault() {}
					};
				}

			}

			[...scripts].forEach((script) => {
				if (script.hasAttribute('data-barba-include')) {
					if (script.src) {
						if (!document.querySelector(`script[src="${script.src}"]`)) {
							const scriptTag = document.createElement('script');
							scriptTag.src = script.src;
							document.head.appendChild(scriptTag);
						}
					} else {
						let src = script.innerHTML;
						try {
							// console.log({ src });
							evalInWindow(src);
						} catch (e) {
							console.error(e);
						}
					}
				}
			});
		});

		barba.hooks.afterLeave(({ current, next, trigger }) => {
			const afterLeaveEvent = new CustomEvent('afterLeave', {
				bubbles: true,
				detail: {
					current,
					next,
					trigger,
				},
			});

			document.dispatchEvent(afterLeaveEvent);
		});

		// Barba settings, transitions and views
		barba.init({
			debug: window.WPURLS.env == 'development' ? true : false,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}

				return false;
			},
			prevent: ({ el, event, href }) => {
				if (/\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(href)) {
					return true;
				}
			},
			transitions: transitions,
		});
	}
}
